import { Box } from "@mui/material";
import { format } from "date-fns";
import { CSVLink } from "react-csv";
import ReactTooltip from "react-tooltip";

import { useInfo } from "@/context/InfoProvider/InfoProvider";
import { colors } from "@/Utils";

import { DownloadIcon } from "../../../../Components/Icons";
import { Span } from "../../../../Components/Typography/Typography";

const TableDownload = ({ name, data, columns }) => {
  const { theme } = useInfo();
  const downloadName = `${name}-${format(new Date(), "dd/MM/yyyy")}`;

  const csvHeaders = columns.map((c) => {
    return {
      label: c.Header,
      key: c.accessor,
    };
  });

  return (
    <Box
      sx={{
        position: "relative",
        width: "30px",
        height: "24px",
        marginLeft: "6px",
      }}
    >
      <div>
        <ReactTooltip
          arrowColor="transparent"
          backgroundColor={theme.mode === "dark" ? colors.darkGray : colors.secondaryColor}
          place="bottom"
          id={`hover-download-${name}`}
          type="dark"
          className="react-tooltip-custom"
        >
          <Span fSize={13} pdtop={5}>
            Download
          </Span>
        </ReactTooltip>
        <Box
          sx={{
            width: "30px",
            height: "24px",
            cursor: "pointer",
          }}
          data-tip
          data-for={`hover-download-${name}`}
        >
          <CSVLink filename={`${downloadName}.csv`} data={data} headers={csvHeaders}>
            <DownloadIcon />
          </CSVLink>
        </Box>
      </div>
    </Box>
  );
};

export default TableDownload;
